import React from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { LIFE_EVENTS } from '../utils/lifeEvents';

// Entrée principale de l'accueil : « Que fêtez-vous ? ». Une tuile par événement de vie, avec ce
// que la boutique propose pour lui (les mêmes entrées que les menus de l'en-tête, lifeEvents.js).
const HomeLifeEvents = () => (
  <Box sx={{ marginBottom: 8 }}>
    <Typography variant="h2" component="h2" sx={{ textAlign: 'center', marginBottom: 1 }}>Que fêtez-vous ?</Typography>
    <Typography sx={{ maxWidth: 680, margin: '0 auto 28px', textAlign: 'center', color: '#7a6060' }}>
      Choisissez votre événement : vous y trouverez nos faire-part et invitations animés, et nos cartes à gratter.
    </Typography>
    <Grid container spacing={3}>
      {LIFE_EVENTS.map((event) => (
        <Grid item xs={12} sm={6} md={3} key={event.key}>
          <Paper variant="outlined" sx={{ overflow: 'hidden', height: '100%' }}>
            <Link to={event.path}>
              <Box component="img" src={event.image} alt={event.titre} loading="lazy" sx={{ width: '100%', aspectRatio: '1', objectFit: 'cover', display: 'block' }} />
            </Link>
            <Box sx={{ padding: 2 }}>
              <Typography variant="h5" component="h3" sx={{ marginBottom: 1 }}>
                <Link to={event.path} style={{ color: 'inherit', textDecoration: 'none' }}>{event.label}</Link>
              </Typography>
              <Box component="ul" sx={{ listStyle: 'none', padding: 0, margin: 0, display: 'grid', gap: 0.5 }}>
                {event.menu.map((item) => (
                  <Typography component="li" variant="body2" key={item.to}>
                    <Link to={item.to} style={{ color: '#7a6060' }}>{item.label}</Link>
                  </Typography>
                ))}
              </Box>
            </Box>
          </Paper>
        </Grid>
      ))}
    </Grid>
  </Box>
);

export default HomeLifeEvents;
